import React, { FC, ReactNode } from 'react';
import { HfsCommonUiThemeWrapper as HudskitThemeWrapper, Toast, lightTheme } from 'hfs-common-ui';
import type { DefaultTheme } from 'styled-components';
import useCustomViewportHeight from '~/hooks/use-custom-viewportHeight';
import { FleetServicesGlobalStyle } from './GlobalStyles';

type Props = {
  children: ReactNode;
  theme?: DefaultTheme;
  ignoreToast?: boolean;
};

export const ThemeWrapper: FC<Props> = ({ children, ignoreToast, theme = lightTheme }) => {
  // hook to set custom viewport height
  useCustomViewportHeight();

  return (
    <HudskitThemeWrapper theme={theme}>
      <>
        <FleetServicesGlobalStyle />
        {children}
        {!ignoreToast && <Toast />}
      </>
    </HudskitThemeWrapper>
  );
};

export default ThemeWrapper;
